import { useState } from 'react'
import GetAppIcon from '@mui/icons-material/GetApp'
import { darken } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { MotionFab } from '@components'
import { colors } from '@global/constants'
import { ExportDatasetDataDialog } from '../exportDatasetDataDialog'
import { DownloadOption } from '../types'
import { t } from '@lingui/core/macro'

interface Props {
  downloadOptions: DownloadOption[]
  downloadOptionsLoading: boolean
  datasetRowCount: number
}

const useStyles = makeStyles(() => ({
  custom: {
    '&&': {
      backgroundColor: colors.green.main,
      '&:hover': {
        backgroundColor: darken(colors.green.main, 0.3),
      },
    },
  },
}))

/**
 * The export template data button in the read grid header
 */
export const ExportTemplateData = ({
  downloadOptions,
  downloadOptionsLoading,
  datasetRowCount,
}: Props) => {
  const classes = useStyles()
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <MotionFab
        color="secondary"
        size="medium"
        tooltipTitle={t`Export data`}
        className={classes.custom}
        onClick={handleOpen}
      >
        <GetAppIcon />
      </MotionFab>
      <ExportDatasetDataDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        downloadOptions={downloadOptions}
        downloadOptionsLoading={downloadOptionsLoading}
        datasetRowCount={datasetRowCount}
      />
    </>
  )

  function handleOpen(): void {
    setDialogOpen(true)
  }
}
